import { ChangeDetectionStrategy, Component, input, type InputSignal } from '@angular/core';

import { IconComponent } from '../../../icon/icon.component';

@Component({
  selector: 'td-wb-modal-sub-header',
  templateUrl: 'modal-sub-header.component.html',
  styleUrls: ['modal-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent]
})
export class ModalSubHeaderComponent {
  readonly iconId: InputSignal<string | undefined> = input<string>();
}
